
import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

export const useCivicEducationRelationships = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [relationships, setRelationships] = useState<any[]>([]);

  const fetchRelationships = async (contentId: string) => {
    setIsLoading(true);
    try {
      console.log('Fetching relationships for content ID:', contentId);
      const { data, error } = await supabase
        .from('civic_content_card_links')
        .select('*')
        .eq('content_id', contentId);
      
      if (error) {
        console.error('Error fetching relationships:', error);
        throw error;
      }
      
      console.log('Fetched relationships:', data);
      setRelationships(data || []);
      return data || [];
    } catch (error) {
      console.error('Error fetching relationships:', error);
      toast.error('Failed to load content relationships');
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const saveRelationships = async (contentId: string, cardIds: string[]) => {
    setIsLoading(true);
    try {
      console.log('Saving relationships for content ID:', contentId, 'Card IDs:', cardIds);
      
      // First delete all existing relationships for this content
      const { error: deleteError } = await supabase
        .from('civic_content_card_links')
        .delete()
        .eq('content_id', contentId);
      
      if (deleteError) {
        console.error('Error deleting existing relationships:', deleteError);
        throw deleteError;
      }
      
      // Only insert new relationships if there are card IDs
      if (cardIds.length > 0) {
        // Create array of relationships to insert
        const relationships = cardIds.map(cardId => ({
          content_id: contentId,
          card_id: cardId
        }));
        
        // Insert new relationships
        const { error: insertError } = await supabase
          .from('civic_content_card_links')
          .insert(relationships);
        
        if (insertError) {
          console.error('Error inserting new relationships:', insertError);
          throw insertError;
        }
      }
      
      toast.success('Relationships updated successfully');
      await fetchRelationships(contentId); // Refresh the relationships
      return true;
    } catch (error) {
      console.error('Error saving relationships:', error);
      toast.error('Failed to update relationships');
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    relationships,
    fetchRelationships,
    saveRelationships
  };
};
